
import detectIndent from 'detect-indent'
import detectNewline from 'detect-newline'

import { List, Record } from 'immutable'
import { Modifier, EditorState } from 'draft-js'
import { getCurrentBlock, addNewBlockAt } from './index'

export const getIndentation = (text = '', editorState) => {
    // Prevent indentation if not at start of text
    if(editorState){
        var selection = editorState.getSelection();
        const textBefore = text.slice(0,selection.getAnchorOffset()).split('\n').slice(-1)[0].replace(/\s/g, "")
        const textAfter = text.slice(selection.getAnchorOffset()).split('\n')[0]
        if(textBefore.length > 0 && textAfter){
            return
        }
    }
    
    // Perform indentation
    const DEFAULT_INDENTATION = '   '
    const result = detectIndent(text)
    return result.indent || DEFAULT_INDENTATION
}

const getNewLine = (text) => {
    return detectNewline(text) || '\n';
}

export const getLines = (text, sep) => {
    sep = sep || getNewLine(text);
    return List(text.split(sep));
}

var LineAnchor = Record({
    // Index of the current line
    line: Number(0),

    // Offset in current line
    offset: Number(0)
});

LineAnchor.prototype.getLine = function() {
    return this.get('line');
};

LineAnchor.prototype.getOffset = function() {
    return this.get('offset');
};

const getLineAnchorForOffset = (text, offset, sep) => {
    sep = sep || getNewLine(text);

    var lineIndex = 0;
    var nextLineIndex = 0;
    var lastLineIndex = 0;

    while (nextLineIndex >= 0 && nextLineIndex < offset) {
        lineIndex++;
        
        lastLineIndex = nextLineIndex;
        nextLineIndex = text.indexOf(sep, nextLineIndex + sep.length);
    }

    return new LineAnchor({
        line: lineIndex - 1,
        offset: offset - lastLineIndex
    });
}

const findAllPos = (text, value, offset = 0) => {
    var re = new RegExp(value,'gi');
    var results = new Array();//this is the results you want
    while (re.exec(text)){
        results.push(re.lastIndex + offset);
    }
    return results
}

export const onUnindent = (editorState, command) => {
    const currentBlock = getCurrentBlock(editorState)
    const contentState = editorState.getCurrentContent()
    const selection = editorState.getSelection()
    const startOffset = selection.getStartOffset()
    const endOffset = selection.getEndOffset()
    const text = endOffset !== 0 ? currentBlock.getText().substring(startOffset, endOffset) : currentBlock.getText() 
    // const indent = getIndentation(text, editorState)
    console.log('[MULTILINE SHIFT-TAB]')
    const startKey = selection.anchorKey;
    const endKey = selection.focusKey
    let nLines = findAllPos(text, '\n', startOffset)
    nLines.unshift(startOffset - currentBlock.getText().slice(0,startOffset).split('\n').slice(-1)[0].length)

    console.log(nLines)
    let newState
    let newContentState
    nLines.map((n,index) => {
        const rangeToRemove = selection.merge({
            focusKey: startKey,
            focusOffset: n - 3*index, 
            anchorKey: startKey,
            anchorOffset: n - 3*index + 3, 
            isBackward: true
        })

        newContentState = Modifier.removeRange(
            newContentState || contentState,
            rangeToRemove,
            'backward'
        );

        newState = EditorState.push(
            newState || editorState,
            newContentState,
            'remove-range'
        );
    })
    const newSelection = selection.merge({
        focusKey: endKey,
        focusOffset: endOffset > startOffset ? endOffset - 3*nLines.length : startOffset - 3, // Start
        anchorKey: startKey,
        anchorOffset: endOffset > startOffset ? startOffset - 3 : endOffset - 3, // End
        isBackward: false
    })
    newState = EditorState.forceSelection(newState, newSelection)
    return newState
    // if (!selection.isCollapsed() & command !== 'backspace') { // Multiline
    //     console.log('[MULTILINE SHIFT-TAB]')
    //     const startKey = selection.anchorKey;
    //     const endKey = selection.focusKey
    //     let nLines = findAllPos(text, '\n', startOffset)
    //     nLines.unshift(startOffset - currentBlock.getText().slice(0,startOffset).split('\n').slice(-1)[0].length)

    //     console.log(nLines)
    //     let newState
    //     let newContentState
    //     nLines.map((n,index) => {
    //         const rangeToRemove = selection.merge({
    //             focusKey: startKey,
    //             focusOffset: n - 3*index, 
    //             anchorKey: startKey,
    //             anchorOffset: n - 3*index + 3, 
    //             isBackward: true
    //         })

    //         newContentState = Modifier.removeRange(
    //             newContentState || contentState,
    //             rangeToRemove,
    //             'backward'
    //         );

    //         newState = EditorState.push(
    //             newState || editorState,
    //             newContentState,
    //             'remove-range'
    //         );
    //     })
    //     const newSelection = selection.merge({
    //         focusKey: endKey,
    //         focusOffset: endOffset > startOffset ? endOffset - 3*nLines.length : startOffset, // Start
    //         anchorKey: startKey,
    //         anchorOffset: endOffset > startOffset ? startOffset - 3 : endOffset, // End
    //         isBackward: false
    //     })
    //     newState = EditorState.forceSelection(newState, newSelection)
    //     return newState
    // } else {
    //     var startKey = selection.getStartKey();
    //     var blockText = currentBlock.getText();

    //     // Detect newline separator and indentation
    //     var newLine = getNewLine(blockText);
    //     var indent = getIndentation(blockText);

    //     // Get current line
    //     var lines = getLines(blockText, newLine);
    //     var lineAnchor = getLineAnchorForOffset(blockText, startOffset, newLine);

    //     var currentLine = lines.get(lineAnchor.getLine());
    //     var beforeSelection = currentLine.slice(0, lineAnchor.getOffset()-1);

    //     // If the line before selection ending with the indentation?
    //     const result = detectIndent(beforeSelection)
    //     if(command === 'backspace' & beforeSelection.replace(/\s/g, "").length > 0){
    //         return // Break for backspace command if got characters before selection
    //     }
    //     else if(result.amount === 0){
    //         return // Break if got no indentation to remove
    //     }

    //     // Remove indent
    //     const offset = beforeSelection.length - getIndentation(beforeSelection).length
    //     console.log({startOffset: startOffset, offset: offset, endOffset: endOffset, text: text})
    //     var rangeToRemove = selection.merge({
    //         focusKey: startKey,
    //         focusOffset: startOffset - offset - 3, // Start
    //         anchorKey: startKey,
    //         anchorOffset: startOffset - offset, // End
    //         isBackward: true
    //     });
    //     let newContentState = Modifier.removeRange(
    //         contentState,
    //         rangeToRemove,
    //         'backward'
    //     );

    //     var newEditorState = EditorState.push(
    //         editorState,
    //         newContentState,
    //         'remove-range'
    //     );
    //     if(indent.length >= 3){
    //         const newSelection = selection.merge({
    //             focusOffset: startOffset - 3,
    //             anchorOffset: startOffset - 3
    //         })

    //         return EditorState.forceSelection(
    //             newEditorState,
    //             newSelection
    //             // newContentState.getSelectionAfter()
    //         );
    //     } 
    // }

    
    
}

export const onIndent = (editorState) => {
    const currentBlock = getCurrentBlock(editorState)
    const contentState = editorState.getCurrentContent()
    const selection = editorState.getSelection()
    const startOffset = selection.getStartOffset()
    const endOffset = selection.getEndOffset()
    const text = endOffset !== 0 ? currentBlock.getText().substring(startOffset, endOffset) : currentBlock.getText() 
    const indent = getIndentation(text, editorState)

    let newState
    let newContentState
    if (!selection.isCollapsed()) { // Multi-selection
        const startKey = selection.anchorKey;
        const endKey = selection.focusKey
        // [TODO] Insert indentation at all the lines detected
        let nLines = findAllPos(text, '\n', startOffset)
        nLines.unshift(startOffset - currentBlock.getText().slice(0,startOffset).split('\n').slice(-1)[0].length)

        console.log(text, {n: nLines, focusKey: selection.focusKey, anchorKey: selection.anchorKey, focusOffset: selection.focusOffset, anchorOffset: selection.anchorOffset})
        nLines.map((n,index) => {
            const rangeToAdd = selection.merge({
                focusKey: startKey,
                focusOffset: n + 3*index, // Start
                anchorKey: startKey,
                anchorOffset: n + 3*index, // End
                isBackward: true
            })
            newContentState = Modifier.insertText(
                newContentState || contentState,
                rangeToAdd,
                '   '
            )
            newState = EditorState.push(
                newState || editorState,
                newContentState,
                'insert-characters'
            );
            
        })
        const newSelection = selection.merge({
            focusKey: endKey,
            focusOffset: endOffset > startOffset ? endOffset + 3*nLines.length : startOffset, // Start
            anchorKey: startKey,
            anchorOffset: endOffset > startOffset ? startOffset + 3 : endOffset, // End
            isBackward: false
        })
        newState = EditorState.forceSelection(newState, newSelection)

    } else {
        newContentState = Modifier.insertText(
            contentState,
            selection,
            indent
        )
        newState = EditorState.push(
            editorState,
            newContentState,
            'insert-characters'
        );
    }
    
    return newState
}

const getIndentForLine = (line) => {
    return detectIndent(line).indent || '';
}

export const insertNewLine = (editorState) => {
    var contentState = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var startOffset = selection.getStartOffset();
    var currentBlock = contentState.getBlockForKey(startKey);
    var blockText = currentBlock.getText();

    var newContentState;

    // Detect newline separation
    var newLine = getNewLine(blockText);

    // Add or replace
    if (selection.isCollapsed()) {
        // Create line to insert with right indentation
        var lines = getLines(blockText, newLine);
        var currentLineIndex = getLineAnchorForOffset(
        blockText,
        startOffset,
        newLine
        ).getLine();
        var currentLine = lines.get(currentLineIndex);
        var lineToInsert = newLine + getIndentForLine(currentLine);

        newContentState = Modifier.insertText(
        contentState,
        selection,
        lineToInsert
        );
    } else {
        newContentState = Modifier.replaceText(
        contentState,
        selection,
        newLine
        );
    }

    var newEditorState = EditorState.push(
        editorState,
        newContentState,
        'insert-characters'
    );

    return EditorState.forceSelection(
        newEditorState,
        newContentState.getSelectionAfter()
    );
}

export const insertNewBlock = (editorState) => {
    const currentBlock = getCurrentBlock(editorState)
    const blockType = currentBlock.getType()
    const blockID = currentBlock.getKey()
    const contentState = editorState.getCurrentContent()
    const selection = editorState.getSelection();
    const text = currentBlock.getText()
    const textAfter = text.slice(selection.getAnchorOffset())
    const lastBlock = contentState.getLastBlock()
    const lastBlockID = lastBlock.getKey()
    if(textAfter.indexOf('\n') === -1 & (blockID === lastBlockID)){
        const newState = addNewBlockAt(editorState, blockID)
        return newState
    }
    return
}